/*
 * This file was automatically generated. Do not make any changes
 * directly as they may be overwritten.
 *
 * To update this file, run `yarn run generate-api`.
 */
import { apiService } from "assets/scripts/domain/apiService";
/* tslint:disable */
export const CONTACT_ANONYMOUS_USER_URL = "/api/contact/anonymous";
export const CONTACT_USER_URL = "/api/contact/user";
export const GET_ANONYMOUS_CONTACT_DATA_URL = "/api/contact/data";
export function contactAnonymousUser(model) {
    return apiService.post(CONTACT_ANONYMOUS_USER_URL, false, {
        model
    });
}
export function contactUser(model) {
    return apiService.post(CONTACT_USER_URL, true, {
        model
    });
}
export function getAnonymousContactData() {
    return apiService.post(GET_ANONYMOUS_CONTACT_DATA_URL, false, {});
}
/* tslint:enable */ 



// WEBPACK FOOTER //
// ./src/generated/api/contact.ts